import { withAITracking  } from "@microsoft/applicationinsights-react-js";
import React from "react";
import { reactPlugin } from "../AppInsights";
import { ObjectDetailsView } from '../features/ObjectsView/ObjectDetails/ObjectDetailsView'

const ObjectDetails = () => {

    return (
        <ObjectDetailsView />
    )
}


export default React.memo(withAITracking(reactPlugin, ObjectDetails));